import React, { useState } from 'react';
import BackorderedDetails from './backordered-details.js';
import DateFormatter from '../../shims/date-formatter.js';
import Warning from "../../warning";
import "./sass/pick-up-details.scss";

function PickupDetails({
	details,
	handleToggle,
	needMoreShown,
	fulfillmentDetails
}) {
	const checkNearByStoresLink =
		<a href="#" className="u__default-link store-inventory-finder-trigger">
			Check Nearby Stores
		</a>;

	const { aisle, bay, store, type, nearbyStore, bossDominant, secondaryBuyOnlineShipToStore} = details;
	const {isBossBopisSharedTile, quantityError} = fulfillmentDetails;

  	const showNeedMore = () => {
		return (bossDominant && secondaryBuyOnlineShipToStore && !fulfillmentDetails.isOosAtOnline);
  	}

	let storeName = store ? store.storeName : "NOT LOCALIZED";

	if (type === "BOPIS") {
		let quantity = store.quantity;
		if (quantity > 0 && !store.isUnavailable) {
			return (
				<div className="heading-message store_pickup_section">
					<span className="dai_detailsMessage">
						<span className="store-box__store-quantity u__bold">
							<span className="u__text--success quantity">{quantity} &nbsp;</span>
						</span>
						in stock at &nbsp;
						<span className="store-box__store-quantity u__bold">
							{storeName}. &nbsp;
						</span>
					</span>
					{showNeedMore() && (
						<a className="u__default-link dai_needMoreLink" onClick={handleToggle}>
							Need More?
						</a>
					)}
					<div>
						{!needMoreShown && checkNearByStoresLink}
					</div>
					{fulfillmentDetails.showBopisCovidAlert && (
						<Warning>
							<span>Due to order volume, this item may not be available for pickup until tomorrow</span>
						</Warning>
					)}
				</div>
			);
		} else {
			let nearbyQuantity = nearbyStore ? nearbyStore.quantity : 0;
			if (nearbyQuantity > 0) {
				let nearbyStoreName = nearbyStore ? nearbyStore.name : "NOT LOCALIZED";
				let distance = nearbyStore ? ("(" + nearbyStore.distance + " mi away)") : "";
				return (nearbyQuantity ?
					<div className="heading-message store_pickup_section">
						<div className="store-box__store-quantity warning_text dai_detailsMessage">
							Not in stock at {storeName}.&nbsp;
						</div>
						<div className="heading-message store_pickup_section" />
						<span className="dai_detailsMessageNearby">
							<div className="store-box__store-quantity u__bold">
								<span className="u__text--success quantity">{nearbyQuantity} &nbsp;</span>
							</div>
							in stock at &nbsp;
							<div className="store-box__store-quantity u__bold">
								{nearbyStoreName}&nbsp;
							</div>
							{distance}. &nbsp;
						</span>
						{checkNearByStoresLink}
						{aisle && bay && !nearbyStore &&
						<div className="u--paddingTop">
							<span className="u__bold contentSpacing">{`Aisle ${aisle}, Bay ${bay} `}</span>
							<a id="aisleBayTooltipOpener" rel="nofollow" href="/p/svcs/taab"
							   className="u__default-link">
								Text to Me
							</a>
						</div>}
						{fulfillmentDetails.showBopisCovidAlert && (
							<Warning>
								<span>Due to order volume, this item may not be available for pickup until tomorrow</span>
							</Warning>
						)}
					</div> : null
				);
	 		}
			else if(!(nearbyQuantity===0 && nearbyStore && nearbyStore.isLimitedQuantity)){
	 			return (
					<div className="heading-message dai_detailsMessage">
						<span className="u__text--danger">Unavailable</span> at {storeName} &nbsp;
						{checkNearByStoresLink}
					</div>
				);
			}

		}

	} else {
		if(bossDominant && isBossBopisSharedTile && quantityError){
			let quantity = store ? store.quantity : null;
			let nearbyQuantity = nearbyStore ? nearbyStore.quantity : 0;
			let nearbyStoreName = nearbyStore ? nearbyStore.name : "";

			let displayQuantity = quantity;
			let displayStore = storeName;
			if(!quantity && nearbyQuantity && nearbyStoreName){
				displayQuantity = nearbyQuantity;
				displayStore = nearbyStoreName;
			}

			let dateRange = details.rawEstimatedStartDeliveryDate !== details.rawEstimatedEndDeliveryDate;
			let expectItDate = dateRange? DateFormatter.convertLongMonthToShort(details.estimatedStartDeliveryDate) + ' - ' +
				DateFormatter.convertLongMonthToShort(details.estimatedEndDeliveryDate) : "";
			return (
				<div>
					<div className="boss-dominant-warning-boss">
					<Warning >
						<span >&nbsp;{displayStore} only has </span>
						<span className='u__bold'>{displayQuantity}</span>
						<span> in stock.</span>
					</Warning>
					</div>
					<div className="u--paddingTop store_pickup_section dai_detailsMessage">
						We'll ship the quantity you need to &nbsp;
						<div className="store-box__store-quantity u__bold">
								{storeName} &nbsp;
						</div>
						for <span className="boss-quantity">free pickup &nbsp;</span>
						<span className="u__bold">{expectItDate}.</span>
					</div>
					<div>
					<a href="#" className="u__default-link store-inventory-finder-trigger">Change Store</a>
					</div>
				</div>
			);
		}else{
			return (
				<div>
					<BackorderedDetails 
						details={details}
						expectItDate={details.estimatedStartDeliveryDate} 
					/>
					<div className="heading-message store_pickup_section dai_detailsMessage">
						We'll send it to &nbsp;
						<div className="store-box__store-quantity u__bold">
								{storeName} &nbsp;
						</div>
						for <span className="u__text--success quantity">free pickup.</span> &nbsp;
						<div>
							<a href="#" className="u__default-link store-inventory-finder-trigger">Change Store</a>
						</div>
					</div>
				</div>
			);
		}

	}
}

export default PickupDetails;
